import { render } from "./input-form.vue?vue&type=template&id=89bcab96"
import script from "./input-form.vue?vue&type=script&lang=js"
export * from "./input-form.vue?vue&type=script&lang=js"
script.render = render

export default script